import { type TablePreferencesConfig } from 'src/common/ui/TablePreferences';

/**
 * Configs for the string detail page's two tables. Neither offers a page size —
 * both render every row unpaged, so a size control would page nothing.
 */

/**
 * Actions is the row's entry point, so `alwaysVisible` and pinned last: the CX ID
 * cell also links, but a user who hid that column would be stranded.
 */
const VARIANT_ACTIONS_COLUMN_ID = 'actions';

export const LOCALES_TABLE_PREFERENCES: TablePreferencesConfig = {
  storageKey: 'LangHub-localesTablePreferences',
  columnOptions: [
    { id: 'locale', label: 'Locale' },
    { id: 'status', label: 'Status' },
    { id: 'translatedText', label: 'Translation' },
  ],
};

export const VARIANTS_TABLE_PREFERENCES: TablePreferencesConfig = {
  storageKey: 'LangHub-variantsTablePreferences',
  columnOptions: [
    { id: 'cxId', label: 'CX ID' },
    { id: 'sourceText', label: 'Variant Source Text' },
    {
      id: VARIANT_ACTIONS_COLUMN_ID,
      label: 'Actions',
      alwaysVisible: true,
    },
  ],
  pinnedLastColumnId: VARIANT_ACTIONS_COLUMN_ID,
};
